module.exports = __webpack_public_path__ + "img/link-icon.047e3003.svg";